import PDFIcon from "../../Images/pdfIcon.png";

const NoticeOfBoardMeeting = () => {
  const documents = [
    {
      title: "Notice of Board Meeting - September 2025",
      buttonLabel: "View Notice of Board Meeting",
      fileName: "Notice-of-Board-Meeting-Sept-25.pdf",
    },
    {
      title: "Notice of Board Meeting - March 2026",
      buttonLabel: "View Notice of Board Meeting",
      fileName: "NOTICE OF BORAD MEETING - March 26.pdf",
    },
    {
      title: "Notice of AGM 2026",
      buttonLabel: "View Notice of Board Meeting",
      fileName: "Notice-of-AGM-2026.pdf",
    },
  ];

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-4">
            <div className="site-heading">
              <span className="site-title-tagline">Investor Information</span>
              <h2 className="site-title">
                Notice of <span>Board Meeting</span>
              </h2>
              <div className="heading-divider"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {documents.map((doc, id) => (
            <div className="col-md-6 col-lg-4" key={id}>
              <div className="team-item p-3">
                <img src={PDFIcon} alt="pdf icon" />
                <div className="team-content">
                  <div className="team-bio">
                    <h5>{doc.title}</h5>
                    <a
                      className="theme-btn mt-2"
                      href={`https://essexmpl.com/Pdf/${doc.fileName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {doc.buttonLabel}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoticeOfBoardMeeting;
